const INVITE_TEXT =
  "سلام شما دعوت شدید به سامانه اسکارپین! \n از این پس سلامت خودرو خود را به اسکارپین بسپارید. \n لینک دانلود: \n https://scarpin.ir/links/app \n در زمان ثبت نام و ورود به اپلیکیشن، کد دعوت خود را وارد نمایید. \n کد دعوت:";
export { INVITE_TEXT };
